import { getAccountKeyForMailboxInfo, isDefaultAccountKey, type AccountKey, } from "owa-client-types";
import type { CalendarEntry, LinkedCalendarEntry } from "owa-graph-schema";

/**
 * Construct the group map key to be a combination of GroupId and userIdentity as the
 * standard groups' GroupIds are same across accounts
 */
export default function getCalendarGroupKey(accountKey: AccountKey, groupId: string): string {
    return `${groupId}_${accountKey}`;
}

export function areCalendarEntriesInSameAccount(firstCalendarEntry: CalendarEntry, secondCalendarEntry: CalendarEntry): boolean {
    const firstAccountKey = getAccountKeyForMailboxInfo(firstCalendarEntry.calendarId.mailboxInfo);
    const secondAccountKey = getAccountKeyForMailboxInfo(secondCalendarEntry.calendarId.mailboxInfo);
    
    return (!isDefaultAccountKey(firstAccountKey) &&
        !isDefaultAccountKey(secondAccountKey) &&
        firstAccountKey === secondAccountKey);
}

export function areCalendarEntriesOrganizationDuplicates(firstCalendarEntry: CalendarEntry, secondCalendarEntry: CalendarEntry, firstIsOrganizationCalendar: boolean, secondIsOrganizationCalendar: boolean): boolean {
    const firstOwnerAddress = (firstCalendarEntry as LinkedCalendarEntry).OwnerEmailAddress;
    const secondOwnerAddress = (secondCalendarEntry as LinkedCalendarEntry).OwnerEmailAddress;
    
    return (firstCalendarEntry.calendarId.id !== secondCalendarEntry.calendarId.id &&
        (firstIsOrganizationCalendar || secondIsOrganizationCalendar) &&
        areCalendarEntriesInSameAccount(firstCalendarEntry, secondCalendarEntry) &&
        !!firstOwnerAddress &&
        !!secondOwnerAddress &&
        firstOwnerAddress.trim().toLowerCase() === secondOwnerAddress.trim().toLowerCase());
}
